@if (data?.title) {
<div mat-dialog-title>
  <h2 class="title">{{ data.title }}</h2>
</div>
}
<mat-dialog-content>
  <div class="py-2">
    <p>{{ data.text }}</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">Non</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true">
    Oui
  </button>
</mat-dialog-actions>
